import { ButtonLink } from '@designsforhealth/dfh-react-components'
import React, { FC } from 'react'
import styled from 'styled-components'
import StyledModal from 'styled-react-modal'

import { RewardsHeading4 } from '../RewardsHeading'
import {
  DetailsPayoutsCardPrimaryButton,
  DetailsPayoutsCardSecondaryButton,
  DetailsPayoutsCardSecondaryButtonLink,
} from './DetailsPayoutsCard'

import CloseIconSvg from '../../../../../img/close.inline.svg'

export interface DetailsPayoutModalProps {
  className?: string
  isOpen: boolean
  onClose: () => void
}

const Modal = StyledModal.styled`
  width: 95%;
  max-width: 555px;
  max-height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: white;
  position: relative;
  border-radius: 8px;
`

const CloseModalButtonLink = styled(ButtonLink)`
  display: block;
  background: none;
  margin: 0;
  padding: 0;
  border: 0;
  position: absolute;
  right: 25px;
  top: 25px;
  z-index: 1;
`

const CloseIcon = styled(CloseIconSvg)`
  width: 16px;
  height: 16px;
`

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 25px;
  overflow: auto;
`

export const DetailsPayoutModalHeading = styled(RewardsHeading4)``

export const DetailsPayoutModalText = styled.p`
  margin-top: 24px;
  margin-bottom: 24px;
`

export const DetailsPayoutModalAlerts = styled.div`
  margin-top: 24px;
`

export const DetailsPayoutModalActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  gap: 24px;
`

export const DetailsPayoutModalPrimaryButton = styled(DetailsPayoutsCardPrimaryButton)`
  width: 50%;
  height: 50px;
`

export const DetailsPayoutModalSecondaryButton = styled(DetailsPayoutsCardSecondaryButton)`
  width: 50%;
  height: 50px;
`

export const DetailsPayoutModalSecondaryButtonLink = styled(DetailsPayoutsCardSecondaryButtonLink)`
  width: 50%;
  height: 50px;
  line-height: 28px;
`

export const DetailsPayoutModal: FC<DetailsPayoutModalProps> = ({
  children,
  className,
  isOpen,
  onClose,
}) => {
  const closeModal = () => {
    onClose()
  }

  return (
    <Modal allowScroll isOpen={isOpen} onBackgroundClick={closeModal} onEscapeKeydown={closeModal}>
      <CloseModalButtonLink onClick={closeModal}>
        <CloseIcon />
      </CloseModalButtonLink>
      <Content className={className}>{children}</Content>
    </Modal>
  )
}
